import { IllustratedMessage, theme } from "kosmos-ui/lib";

import { useShopper } from "app/context/ShopperContext/hooks";

import { ShopperBrowserSection } from "../../styles";
import { shopperOrdersIllustratedMessageStyle } from "./styles";
import ShopperOrderCard from "./components/ShopperOrderCard";

export default function ShopperOrdersSection() {
  const { shopper } = useShopper();

  const orders = shopper?.orders;

  if (!orders) return null;

  if (orders.length === 0)
    return (
      <IllustratedMessage
        illustration="emptyInbox"
        header="Aún no tienes compras"
        body="Una vez compres productos tus órdenes aparecerán aquí!"
        mainContainerStyle={shopperOrdersIllustratedMessageStyle}
        headerStyle={{ color: theme.colorsPalette.white.default }}
      />
    );

  return (
    <ShopperBrowserSection>
      {orders.map((order) => (
        <ShopperOrderCard key={order._id} order={order} />
      ))}
    </ShopperBrowserSection>
  );
}
